module.exports = __webpack_public_path__ + "static/media/4.c6968ada.png";